export default {
  DATA: 'dataLayer/data',
};
